import React, { FC } from "react";
import { CardPrice } from "src/components/Card/CardPrice";
import { ButtonChat } from "src/components/ButtonChat";
import { getImageUrl } from "src/utils/getImageUrl";
import { ILocation } from "src/@types/users";

interface Props {
  main_photo?: string;
  title: string;
  cost: number;
  location: ILocation;
  chatId: number;
}

export const ApprovedDealRequestHead: FC<Props> = ({
  main_photo,
  title,
  cost,
  location,
  chatId,
}) => (
  <div className="flex h-14 bg-purple-lighter mt-3 xl:mt-0 rounded-20">
    {main_photo && (
      <div className="min-w-80 hidden md:block">
        <img
          className="w-full h-full object-cover object-center rounded-20"
          src={getImageUrl(main_photo)}
          alt={title}
        />
      </div>
    )}

    <div className="flex flex-1 justify-between items-center gap-5 px-3 sm:px-5">
      <h4 title={title} className="line-clamp-1">
        {
          "Our investor from Canada is seeking to clone a company in the Education industry. The goal is to implement innovative e-learning solutions and digital educational resources in the Canadian market. "
        }
      </h4>

      <div className="hidden sm:flex gap-5">
        <CardPrice price={cost}/>

        <div>
          <img
            src={getImageUrl(location.country.icon)}
            alt={location.country.name}
          />
        </div>
      </div>
    </div>

    <ButtonChat
      className="max-w-max hidden lg:block"
      chatId={chatId}
      isActiveStatus
    />
  </div>
);
